const container = document.querySelector('.slider-element');
if (container) {
  const debounce = (fn, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), delay);
    };
  };

  const wait = (ms) => new Promise((r) => setTimeout(r, ms));

  const handleProductClick = async (event) => {
    const card = event.target.closest('.product-card');
    if (!card || !container.contains(card)) return;
    event.preventDefault();
    const img = card.querySelector('img');
    if (img && !img.hasAttribute('loading')) img.setAttribute('loading', 'lazy');

    if (img) img.style.viewTransitionName = 'full-embed';

    const url = card.href;

    if (document.startViewTransition) {
      await document.startViewTransition(async () => {
        await Promise.race([document.fonts.ready, wait(100)]);
        window.location.href = url;
      });
    } else {
      window.location.href = url;
    }
  };

  const debouncedHandler = debounce(handleProductClick, 100);

  container.addEventListener('click', debouncedHandler);

  window.addEventListener('unload', () => {
    container.removeEventListener('click', debouncedHandler);
  });
}
